// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__f-bGO","banner__image":"Banner_banner__image__2zA21","banner__content":"Banner_banner__content__3-lpe","btn_banner":"Banner_btn_banner__29UQX"};